/**
 * @generated SignedSource<<a4dd7fd86c68ebfc1a1fec3718e950d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionPreview_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPrice_item" | "PdpSharedAuctionCountdown_item" | "PriceDisplay_item" | "useAuctionPricing_item">;
  readonly " $fragmentType": "PdpSharedAuctionPreview_item";
};
export type PdpSharedAuctionPreview_item$key = {
  readonly " $data"?: PdpSharedAuctionPreview_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionPreview_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionPreview_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OriginalListPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdown_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b9e31d24dd1f9983fd643acaa17ee68a";

export default node;
